var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoBinamik = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.244,
    height: 32,
    viewBox: "0 0 106.244 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a{opacity:0;}.b{fill:#1ed6bb;}.c{fill:#025670;}.d{fill:#005670;}\n      .e{fill:#2d2d2d;}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-78 -118)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(78 118)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 32
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-163.653 -3.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M224.454,149.52l4-4-4-4,3.777-3.777,7.776,7.777L228.23,153.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M228.23,137.967l7.553,7.553-7.553,7.553-3.553-3.553,3.777-3.776.223-.224-.223-.223-3.777-3.777,3.553-3.553m0-.447-4,4,4,4-4,4,4,4,8-8-8-8Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-163.653 -3.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M224.454,133.52l4-4-4-4,3.776-3.777,7.776,7.776L228.23,137.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M228.23,121.967l7.553,7.553-7.553,7.553-3.553-3.553,3.777-3.776.223-.224-.223-.223-3.777-3.777,3.553-3.553m0-.446-4,4,4,4-4,4,4,4,8-8-8-8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M220.653,137.967l7.553,7.553-7.553,7.553L217.1,149.52l3.777-3.776.223-.224-.223-.223L217.1,141.52l3.553-3.553m0-.447-4,4,4,4-4,4,4,4,8-8-8-8Z",
    transform: "translate(-163.653 -3.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M220.653,121.967l7.553,7.553-7.553,7.553L217.1,133.52l3.777-3.776.223-.224-.223-.223L217.1,125.52l3.553-3.553m0-.447-4,4,4,4-4,4,4,4,8-8-8-8Z",
    transform: "translate(-163.653 -3.52)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-163.653 -3.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 7.578,
    height: 0.312,
    transform: "translate(220.653 121.52)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-163.653 -3.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 7.576,
    height: 0.312,
    transform: "translate(220.654 153.208)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-163.653 -3.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 7.779,
    height: 0.312,
    transform: "translate(228.281 145.364)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-163.653 -3.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 7.579,
    height: 0.312,
    transform: "translate(228.344 129.364)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-446.724 -1559.719)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M479.035,1571.916a5.907,5.907,0,0,0-3.38,1.058v-5.983h-2.931v16.45h2.931v-.712a5.935,5.935,0,1,0,3.38-10.813Zm0,9.315a3.381,3.381,0,0,1-3.38-3.379h0a3.38,3.38,0,1,1,3.38,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M512.633,1572.974a5.935,5.935,0,1,0,0,9.755v.712h2.931v-11.179h-2.931Zm-3.38,8.257a3.38,3.38,0,1,1,3.38-3.38A3.38,3.38,0,0,1,509.253,1581.231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M487.946,1566.718a1.779,1.779,0,0,0-1.318.557,1.834,1.834,0,0,0-.545,1.329,1.772,1.772,0,0,0,.545,1.3,1.866,1.866,0,0,0,2.636,0,1.768,1.768,0,0,0,.545-1.3,1.822,1.822,0,0,0-.545-1.341A1.8,1.8,0,0,0,487.946,1566.718Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 3.022,
    height: 11.179,
    transform: "translate(486.447 1572.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M497.757,1571.967a4.214,4.214,0,0,0-1.864.431,3.125,3.125,0,0,0-1.363,1.25v-1.386H491.6v11.179h3.022v-6.43a2.449,2.449,0,0,1,.568-1.659,2.18,2.18,0,0,1,3.079-.045,2.435,2.435,0,0,1,.511,1.613v6.521H501.8V1576.4a4.816,4.816,0,0,0-1.034-3.192A3.7,3.7,0,0,0,497.757,1571.967Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M530.689,1571.944a3.954,3.954,0,0,0-3.545,1.863,3.328,3.328,0,0,0-3.317-1.863,4.3,4.3,0,0,0-1.908.454,3.012,3.012,0,0,0-1.364,1.227v-1.363H517.67v11.179h3.022V1576.9a2.257,2.257,0,0,1,.568-1.579,1.954,1.954,0,0,1,1.522-.625,1.846,1.846,0,0,1,1.477.579,2.27,2.27,0,0,1,.5,1.534v6.635h3V1576.9a2.27,2.27,0,0,1,.568-1.568,1.911,1.911,0,0,1,1.5-.636,1.84,1.84,0,0,1,1.489.579,2.306,2.306,0,0,1,.488,1.534v6.635h2.931v-7.248a3.862,3.862,0,0,0-4.044-4.249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M538.387,1566.718a1.776,1.776,0,0,0-1.318.557,1.831,1.831,0,0,0-.545,1.329,1.768,1.768,0,0,0,.545,1.3,1.865,1.865,0,0,0,2.635,0,1.769,1.769,0,0,0,.546-1.3,1.823,1.823,0,0,0-.546-1.341A1.8,1.8,0,0,0,538.387,1566.718Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 3.022,
    height: 11.179,
    transform: "translate(536.887 1572.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M548.4,1576.965l4.476-4.7h-3.953l-3.863,4.158v-9.429h-3.022v16.45h3.022v-2.954l1.25-1.318,2.954,4.272h3.7Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBinamik);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoBinamik.65ec07856f569af3e71f0fb5fcae3bc2.svg";